import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20composition%20with%20soft%20flowing%20gradients%20in%20coral%20and%20warm%20peach%20tones%2C%20subtle%20texture%20overlay%2C%20dreamy%20and%20elegant%20atmosphere%2C%20minimalist%20artistic%20background%20with%20gentle%20color%20transitions%2C%20no%20text%20or%20letters&width=1800&height=600&seq=cta-bg-hanman&orientation=landscape')`,
        }}
      >
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/40"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-background-50 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
          准备好开始你的韩漫之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-background-50/70 mb-8 max-w-xl mx-auto">
          数千部精选韩漫等你来探索，免费下拉式阅读，随时随地畅享精彩故事。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/fantasy"
            className="px-8 py-3 bg-accent-500 text-background-50 rounded-full text-sm font-semibold hover:bg-accent-600 transition-all duration-300 whitespace-nowrap"
          >
            立即探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/10 backdrop-blur-sm text-background-50 rounded-full text-sm font-semibold hover:bg-background-50/20 transition-all duration-300 border border-background-50/20 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}